<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="tournament-back d-flex justify-content-start align-items-center">
          <router-link class="tournament-back-link cursor-pointer" :to="{ path: '/tournament-details', query: { tournament_id: tournamentId}}"> ← </router-link>
          <div class="tournament-page-title">
            {{ $t('RECENT_BEST') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" v-for="ranking in rankingList" :key="ranking.user_id">
        <div class="bcs-content d-flex justify-content-between align-items-center" @click="setRankingUser(ranking)">
          <div class="d-flex align-items-center">
            <img :src="ranking.image_url"
                 class="rounded-circle"
                 width="50"
                 :alt="ranking.name"/>
            <div class="rank rounded-circle ">
              <p>{{ convertNumberToLangWise(ranking.position) }}</p>
            </div>
            <div class="d-flex-column m-lg-3">
              <p class="p-name">{{ ranking.name }}</p>
              <p class="p-level">{{ $t('LEVEL') }} {{ convertNumberToLangWise( ranking.level ) }}</p>
            </div>

          </div>
          <div style="color: #F42F75"> {{ convertNumberToLangWise(ranking.points) }}</div>
        </div>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 d-flex justify-content-center align-items-center">
        <v-pagination
            v-model="page"
            :pages="pageCount"
            :range-size="1"
            active-color="#DCEDFF"
            @update:modelValue="updateHandler"
        />
      </div>
    </div>
  </div>
  <RankingModal :modal-show="showModal"
                :ranking-user="rankingUser"
                v-if="showModal"/>
</template>

<script>
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import RankingModal from "@/views/components/RankingModal";

export default {
  name: "RecentBestAll",
  components: {
    Loader,
    VPagination,
    RankingModal
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      page: 1,
      perPage: 20,
      pageCount: 0,
      rankingList: [],
      tournamentId: this.$route.query.tournament_id,
      rankingType: this.$route.query.type,
      showModal: false,
      rankingUser: [],
    }
  },
  created() {
    this.getRankingList();
    this.emitter.on('modal-close-event', (evt) => {
      this.showModal = evt.eventContent;
      this.rankingUser = [];
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    getRankingList() {
      this.loaderActive = true;
      let data, url;
      if (this.rankingType === 'tournament') {
        data = {
          page: this.page,
          per_page: this.perPage,
          tournament_id: this.tournamentId,
        };
        url = 'v2.0/tournament/ranking';
      } else {
        data = {
          page: this.page,
          per_page: this.perPage,
          topic_id: this.tournamentId,
        };
        url = 'v2.0/topic/ranking';
      }
      sendRequest('post', url, data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.rankingList = response.data.ranking;
              this.pageCount = response.data.page_count;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    updateHandler(event) {
      this.page = event;
      this.getRankingList();
    },
    setRankingUser(user_data) {
      this.rankingUser = user_data;
      this.showModal = true;
    },
  }
}
</script>

<style scoped>

</style>
